import { render } from "./modelfour.vue?vue&type=template&id=18a068b6"
import script from "./modelfour.vue?vue&type=script&lang=js"
export * from "./modelfour.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__